
import { defineComponent } from "vue";
import npxTable from "@/components/neopixel/npxTable.vue";

export default defineComponent({
  name: "programs-list",
  components: {
    npxTable,
  },
});
